var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-24-/-Outline-/-Travel,-Transport-+-Tracking-/-drive_-Copy-10",
    transform: "translate(-2.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -1.77635684e-14,
    y: -5.00000858e-8,
    width: 24.0000001,
    height: 24.0000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,17 L16,17 L16,9 L14,9 L14,17 Z M8.00000005,17 L10,17 L10,9 L8.00000005,9 L8.00000005,17 Z M6.00000005,19 L18,19 L18,7 L6.00000005,7 L6.00000005,19 Z M2.00000005,5 L2.00000005,7 L4.00000005,7 L4.00000005,19 C4.00000005,20.104 4.89600005,21 6.00000005,21 L18,21 C19.104,21 20,20.104 20,19 L20,7 L22,7 L22,5 L2.00000005,5 Z M7.00000005,3 L17,3 L17,1 L7.00000005,1 L7.00000005,3 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fill: "#FF6666"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashHover);
export default __webpack_public_path__ + "static/media/trash_hover.f813c0b314007ad27d65ac32c6b7f1e4.svg";
export { ForwardRef as ReactComponent };